var parameterInsert={ 
    IdEnterprise:'',
    Name:'', 
    ActiveQuestions:'2',
    ActiveItems:'2',
    ActiveAnswerNonconformities:'2',
    ActiveGeolocation:'2',
    ActiveResponsible: '2',
    IsMetaProd:'2',
    Active:'1',
    User:'',
    IP:''
} 
var parameterUpdate={
    IdEnterprise:'',
    IdDocType:'',
    Name:'', 
    ActiveAnswerNonconformities:'2',
    ActiveGeolocation:'2',
    ActiveResponsible: '2',
    IsMetaProd:'2',
    Active:'1',
    User:'',
    IP:''
} 
var parameterView={ 
    IdEnterprise:'',
    Name:'',  
    Active:'2'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}